<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
body {
  background: linear-gradient(#E6F2FB, #FFFFFF);
}
* {
  padding:0;
  margin:0;
  vertical-align:baseline;
  list-style:none;
  border:0
}
</style>
